import { useState } from 'react'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'

interface ExpiredSessionModalProps {
  open: boolean
  /**
   * Called only when the user clicks View Attempts. The modal cannot be
   * dismissed via X, Esc, or click-outside — the user must acknowledge.
   */
  onDismiss: (suppressFuture: boolean) => void
}

/**
 * Mandatory notification modal shown after the server has auto-expired a
 * session because more than 24h passed since last activity. The session is
 * already closed by the time this renders.
 */
export function ExpiredSessionModal({
  open,
  onDismiss,
}: ExpiredSessionModalProps) {
  const [suppressFuture, setSuppressFuture] = useState(false)

  return (
    <Dialog open={open}>
      <DialogContent
        showCloseButton={false}
        onPointerDownOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle>Your previous session has expired</DialogTitle>
          <DialogDescription>
            More than 24 hours passed since you last worked on this problem, so
            the session was closed. You can view or restore your previous code
            from the Attempts tab.
          </DialogDescription>
        </DialogHeader>

        <label className="flex cursor-pointer items-center gap-2 text-sm text-muted-foreground">
          <input
            type="checkbox"
            checked={suppressFuture}
            onChange={(e) => setSuppressFuture(e.target.checked)}
            className="rounded border-border"
          />
          Don't show this again for expired sessions
        </label>

        <DialogFooter>
          <Button onClick={() => onDismiss(suppressFuture)}>
            View Attempts
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
